import { create } from "../../../common/utils/zustand_state_manager";
import { IAdministracaoService } from "../../../features/administracao/data/services/administracao_service";
import { AdministracaoService } from "../../../features/administracao/data/services/administracao_service_impl";

/**
 * useAdministracaoServices
 */

type State = {
  administracaoService: IAdministracaoService,
};

export const useAdministracaoServices = create<State>((set, get) => ({
  administracaoService: new AdministracaoService(),
}));